export const localizationModule = {
  current: "en",
  en: {
    whyus: "Why us?",
    terms: "Terms",
    privacy: "Privacy",
    "top-rating": "4.9 Rating",
    howitworks: "How It Works",
    applynow: "Get Started",
    benefits: "Benefits",
    faq: "FAQ",
    "h1-top": "Get Business Funding",
    "h1-mid": "Up To $1M",
    "h1-bot": "In 24 Hours",
    "hero-text": `<b>Grow Now</b> Based On Your Future Revenue. Our AI technology instantly approves up to $500K for successful businesses like yours. 
From approval to funding in 24 hours.</br> <b>Because Your Growth Can't Wait.</b>`,
    understandingcapital: "Understanding Working Capital",
    buisinessgrow: "Business Growth Tips",
    financialplanning: "Financial Planning for Small Businesses",
    "why-choose": "Why Choose Business Capital Advance?",
    "why-choose-descr": "No pitching, no meetings, no hassle.",
    "cashAdvance.title1": "Instant AI Approval",
    "cashAdvance.desc1":
      "Get up to $500K within 24 hours. Making $100K+? Get funded tomorrow.",
    "cashAdvance.title2": "Revenue-Based Payments",
    "cashAdvance.desc2":
      "Flexible repayment that matches your business cash flow. Keep more capital when needed.",
    "cashAdvance.title3": "Simple Qualification",
    "cashAdvance.desc3":
      "No collateral needed - qualify based on your revenue strength.",
    "cashAdvance.title4": "5-Minute Application",
    "cashAdvance.desc4":
      "AI-powered decisions. Basic business info only - get approved instantly.",
    "cashAdvance.title5": "Minimal Paperwork",
    "cashAdvance.desc5":
      "Streamlined application process designed with your time in mind.",
    "last-card": "Wanna learn more?",
    "btn-apply": "Get Funded Now",
    "about-procash": "About ProCash.ai",
    "desc-procash":
      "With over 6 years of experience in business financing, ProCash.ai has been a trusted partner for thousands of businesses across USA. Our mission is to provide accessible, flexible, and transparent funding solutions that empower businesses to thrive.",
    "time-works": "6+ years",
    "our-mission": " Our mission’s to drive grow & improve progress.",
    clients: "990+ clients",
    "how-works": "How It Works",
    "how-works.title1": "Simple Application Process",
    "how-works.desc1":
      "Complete our quick online application with your business information",
    "how-works.title2": "Fast Approval",
    "how-works.desc2":
      "Our team reviews your application promptly, often within 2 Hours.",
    "how-works.title3": "Receive Funds Quickly",
    "how-works.desc3":
      "Approved businesses receive funds directly in their bank accounts within 24 hours.",
    "how-works,title4": "Flexible Repayment",
    "how-works.desc4":
      "Repayments are automatically deducted as a percentage of your daily future, ensuring payments align with your revenue.",
    "benefits-section": "Benefits of ProCash.ai",
    "benefits-section.title1": "Transparent Terms",
    "benefits-section.desc1":
      "No hidden fees or surprises—understand exactly what you're signing up for.",
    "benefits-section.title2": "Personalized Support",
    "benefits-section.desc2":
      "Our dedicated team work with you to tailor the best financing solution for your business.",
    "benefits-section.title3": "Boost Your Business",
    "benefits-section.desc3":
      "Use your advance to invest in inventory, marketing, equipment, or any area that drives growth.",
    "benefits-section.title4": "Maintain Control",
    "benefits-section.desc4":
      "Unlike equity financing, you retain full ownership and control of your business.",
    "success-section": "Success Stories",
    "success-section.desc1":
      "Partnering with ProCash.ai was a game-changer for our restaurant. The funds allowed us to renovate our space and increase our seating capacity, leading to a 30% boost in revenue!",
    "success-section.owner1": "Restaurant Owner",
    "success-section.opening1": "From 2024",
    "success-section.desc2":
      "procash.ai provided quick funds for my auto repair shop. I bought new tools and kept my business running smoothly.",
    "success-section.owner2": "Restaurant Manager",
    "success-section.opening2": "From 2023",
    "success-section.desc3":
      "With procash.ai, my construction company got the advance fast. We bought new materials and started more projects!",
    "success-section.owner3": "Restaurant Owner",
    "success-section.opening3": "From 2022",
    "faq-section-top": "Have Questions?",
    "faq-section-bot": " We're Here to Help!",
    "faq-section-desc":
      "Contact our friendly support team to learn more about how a working capital can benefit your business.",
    "faq-section-sub-section": "Still have questions?",
    "faq-section-sub-section-top":
      " If the question is not available on our FAQ",
    "faq-section-sub-section-bot":
      " section, Feel free to contact us personally.",
    "faq-btn": "Ask a Question",
    "faq-title1": "How do I apply?",
    "faq-desc1":
      "Applying for a working capital with ProCash.ai is quick and easy. Simply visit our website and complete the online application form with your business details. Our team will review your information and reach out to you promptly to guide you through the next steps.",
    "faq-title2": "Will applying with ProCash.ai impact my credit score?",
    "faq-desc2":
      "No, applying for a working capital with ProCash.ai does not affect your personal or business credit score. We evaluate your application based on your business’s cash flow and revenue, ensuring a hassle-free process without impacting your credit history.",
    "faq-title3": "Which documents will I need to present to apply?",
    "faq-desc3":
      "To apply for a working capital with ProCash.ai, you'll need to provide basic business information, including recent bank statements (typically the last 3-6 months) and any relevant identification documents. Our streamlined process minimizes the paperwork required, making it easier for you to get the funds you need.",
    "faq-title4": "How do I access my funds?",
    "faq-desc4":
      "Once your application is approved, the funds are typically deposited into your business bank account within 24 to 48 hours. We prioritize speed and efficiency to ensure that you receive the capital you need promptly to support and grow your business.",
    "faq-title5": "How much funding can my business get?",
    "faq-desc5":
      "Your business can qualify for $20K-$1M in fast capital. Annually revenue of $100K+ unlocks higher funding amounts with instant approval. Get funded tomorrow based on your revenue performance.",
    "faq-title6": "What are the requirements?",
    "faq-desc6":
      "We work with businesses that have: <ul><li>+$20K Monthly revenue</li><li>1+ Years in operation</li><li>Valid business bank account</li><li>US-based operations</li></ul>",
    "faq-title7": "How fast can I get funded?",
    "faq-desc7":
      "Qualified businesses receive funding within 24 hours of approval. Our AI technology provides instant decisions.",
    "faq-title8": "Will my credit score be affected by this application?",
    "faq-desc8":
      "No. Because Procahs is not a loan, our rejection would not affect your credit score.",
    "faq-title9": "What is an Invoice Financing Business?",
    "faq-desc9":
      "Invoice financing is when lenders offer you a business loan based on your outstanding invoices. Instead of waiting for customers to pay, a lender advances a percentage of the invoice value, providing immediate cash flow. Once the invoices are paid by the customers, the business repays the lender, typically with a small fee. This is a great option for businesses that need quick access to working capital to cover expenses or invest in growth.",

    "testtimonials-section": "Testimonials",
    "testimonial-desc1":
      "procash.ai helped me get money fast for my restaurant. Now, I can fix our kitchen and serve more customers!",
    "testimonial-user1": "Carlos",
    "testimonial-from1": "from Miami",
    "testimonial-desc2":
      "Thanks to procash.ai, my beauty salon got funds quickly. I bought new equipment and now have more clients!",
    "testimonial-user2": "Jasmine",
    "testimonial-from2": "from Atlanta",
    "validation.policy.required": "Privacy policy is required",
    "testimonial-desc3":
      "Using procash.ai was super easy. My boutique got the cash I needed to stock up for the holidays!",
    "testimonial-user3": "Emily",
    "testimonial-from3": "from New York City",
    thankYouMessage1:
      "Our team is already reviewing your details. A dedicated funding specialist will call you shortly to finalize your approval and initiate the transfer of your funds.",
    "testimonial-desc4":
      "procash.ai provided quick funds for my auto repair shop. I bought new tools and kept my business running smoothly.",
    "testimonial-user4": "Michael",
    "testimonial-from4": "from Chicago",
    "testimonial-desc5":
      "With procash.ai, my construction company got the advance fast. We bought new materials and started more projects!",
    "testimonial-user5": "David",
    "testimonial-from5": "from Houston",
    "ready-section": "Ready to Propel Your Business Forward?",
    "ready-info":
      " Take the next step in your business journey with a working capital from ProCash.ai. Our team is here to provide the funding you need with terms that work for you.",
    "ready-btn": "Create account",
    FinancialPlanning: "Financial Planning for Small Businesses",
    Allrightsreserve: "All rights reserve",
    grownow: "Grow Now ",
    basedonfuture: " based on your future revenue",
    Receiveupto: "Receive up to ",
    inflexiblefinancing:
      "in flexible financing, tailored for growing businesses.",
    yourbusinesseamil: "Your Business Email",
    yourbusinessname: "Your Business Name",
    businessname: "Business Name",
    yourphone: "Your phone number",
    phonenotvalid: "Your phone number is not valid",
    phone: "Phone number",
    getstarted: "Get Started",
    Qualifyingbusinesses:
      "Qualifying businesses receive up to $200K in 24 hours.",
    iagreeto: "I agree to ",
    and: "and ",
    returnaportion: "Return a portion of your daily income.",
    yourfullname: "Your Full Name",
    fullname: "Full Name",
    home: "Home ",
    appform: "Application Form",
    welcometo: "Welcome to ",
    stepone: "Step 1: Basic Information",
    steptwo: "Step 2: Business Details",
    stepthree: "Step 3: Financial Information",
    subtext: "Subtext",
    needhelp: "Need Help?",
    gettoknowreach: "Get to know how your campaign can reach a wider audience.",
    contactus: "Contact Us",
    emailaddress: "Email Address",
    nextstep: "Next Step",
    save: "Save",
    thankYouMessage2: "Before we proceed, how would you prefer to communicate?",
    thankYouMessage: "Thank You!",
    businesstype: "Business Type / Industry",
    "Business Establishment Date": "Business Establishment Date",
    businessaddress: "Business Address",
    "Monthly Revenue": "Monthly Revenue",
    "Requested Ammount": "Requested Amount",
    "Credit score range": "Credit score range",
    "Consent to Credit Check": "Consent to Credit Check",
    iauthorize:
      "I authorize ProCash.ai to perform a credit check on myself and my business for the purpose of this  application",
    "Agreement to Terms & Conditions": "Agreement to Terms & Conditions",
    "Previous Step": "Previous Step",
    below: "Below ",
    above: "Over  ",
    "Business State": "Business State",
    AverageMonthly: "Average Monthly Credit Card Sales",
    AverageMonthlyDebit: " Average Monthly Debit Card Sales",
    OtherMonthlyRevenue: "Other Monthly Revenue Sources",
    optional: "Optional",
    anyexistingloans: "Do you have any existing loans or financing?",
    yes: "Yes",
    no: "No",
    TotalExistingAmount: "Total Existing Financing Amount",
    MonthlyPaymentAmount: "Monthly Payment Amount",
    BankInformation: "Bank Account Information",
    UploadDocuments: "Upload Bank Statements",
    Chooseafile: "Choose a file or drag & drop it here.",
    allowedfiletype: "Allowed file types: PDF, DOC, JPG. Max size: 5MB",
    "Browse File": "Browse File",
    Submit: "Submit",
    Application: "Application",
    protected: `Your files are safeguarded with top-tier security measures, ensuring complete protection. Uploading is completely secure and has no impact on your credit score.`,
    foundLander: `We found the best match for you and your funding is READY ! – upload your business bank statements now to secure fast approval and get your funds without delay!`,
    greatNews: "Great news!",
    holdTight: "Hold tight!",
    searchLenders: "We’re searching 50+ lenders to find your best match…",
    lendersChecked: "Lenders Checked",
    lendersFound: "We found the perfect funder for you!",
    returnToTheForm: "Complete the form",
    "validation.full_name.min": "Full Name must be at least 2 characters",
    "validation.full_name.max": "Full Name must not exceed 50 characters",
    "validation.full_name.required": "Full Name is required",

    "validation.business_name.min":
      "Business Name must be at least 2 characters",
    "validation.business_name.max":
      "Business Name must not exceed 100 characters",
    "validation.business_name.required": "Business Name is required",

    "validation.email.invalid": "Invalid email address",
    "validation.email.required": "Email is required",

    "validation.phone.digits": "Phone number must contain only digits",
    "validation.phone.min": "Phone number must be at least 10 digits",
    "validation.phone.max": "Phone number must not exceed 15 digits",
    "validation.phone.required": "Phone number is required",

    "validation.business_type.required": "Business Type is required",

    "validation.business_date.required": "Business Date is required",
    "validation.business_date.min_6_months":
      "Business Establishment Date must be at least 6 months ago",

    "validation.business_address.min":
      "Business Address must be at least 5 characters",
    "validation.business_address.max":
      "Business Address must not exceed 200 characters",
    "validation.business_address.required": "Business Address is required",

    "validation.business_state.required": "Business State is required",
    "validation.monthly_revenue.required": "Monthly Revenue is required",

    "validation.avg_monthly_credit.number": "Credit Score must be a number",
    "validation.avg_monthly_credit.required": "Credit Score is required",

    "validation.current_funding.required": "Current Funding is required",

    "validation.consent_credit_check.required":
      "Consent to credit check is required",

    "validation.terms_conditions.required":
      "You must agree to the terms and conditions",
    thankYouMessage3:
      "(Select your preferred option to ensure a smooth process.)",
    phoneCall: "Phone Call",
    lowRevenueInfo: `To qualify, your business must generate at least <span style="color:#f04f4f;">$15,000</span> in monthly revenue. Applications below this amount are not eligible for funding.`,
  },
  es: {
    lowRevenueInfo: `Para calificar, su negocio debe generar al menos <span style="color:#f04f4f;">$15,000</span> en ingresos mensuales. Las solicitudes por debajo de esta cantidad no son elegibles para recibir financiamiento.`,
    phoneCall: "Llamada telefónica",
    thankYouMessage3:
      "(Seleccione su opción preferida para garantizar un proceso sin problemas.)",
    lendersFound: "¡Encontramos el financiador perfecto para usted!",
    lendersChecked: "Prestamistas comprobados",
    searchLenders:
      "Estamos buscando entre más de 50 prestamistas para encontrar la mejor opción para usted...",
    holdTight: "Mantener apretado!",
    greatNews: "¡Buenas noticias!",
    foundLander:
      "¡Encontramos la mejor opción para usted y su financiación está LISTA! – ¡Cargue ahora sus extractos bancarios comerciales para garantizar una aprobación rápida y obtener sus fondos sin demora!",
    protected: `Tus archivos están protegidos con medidas de seguridad de primer nivel, lo que garantiza una protección completa. Subir archivos es completamente seguro y no afecta tu puntaje crediticio.`,
    Application: "Aplicación",
    Submit: "Enviar",
    "Browse File": "Explorar archivo",
    allowedfiletype:
      "Tipos de archivos permitidos: PDF, DOC, JPG. Tamaño máximo: 5 MB",
    Chooseafile: "Elija un archivo o arrástrelo y suéltelo aquí.",
    UploadDocuments: "Subir extractos bancarios",
    BankInformation: "Información de la cuenta bancaria",
    MonthlyPaymentAmount: "Monto del pago mensual",
    TotalExistingAmount: "Monto total de financiación existente",
    no: "No",
    anyexistingloans: "¿Tiene algún préstamo o financiación existente?",
    optional: "Opcional",
    OtherMonthlyRevenue: "Otras fuentes de ingresos mensuales",
    AverageMonthlyDebit: "Ventas mensuales promedio con tarjeta de débito",
    AverageMonthly: "Ventas mensuales promedio con tarjeta de crédito",
    "Business State": "Estado empresarial",
    above: "Más de ",
    below: "Abajo ",
    "Previous Step": "Paso anterior",
    "Agreement to Terms & Conditions": "Aceptación de términos y condiciones",
    iauthorize:
      "Autorizo ​​a ProCash.ai a realizar una verificación de crédito sobre mí y mi empresa a los efectos de esta solicitud.",
    "Consent to Credit Check": "Consentimiento para verificación de crédito",
    "Credit score range": "Rango de puntuación crediticia",
    "Requested Ammount": "Cantidad solicitada",
    "Monthly Revenue": "Ingresos mensuales",
    businessaddress: "Dirección comercial",
    "Business Establishment Date": "Fecha de constitución de la empresa",
    businesstype: "Tipo de negocio/industria",
    save: "Ahorrar",
    nextstep: "Siguiente paso",
    emailaddress: "Dirección de correo electrónico",
    contactus: "Contacta con nosotros",
    gettoknowreach:
      "Descubra cómo su campaña puede llegar a un público más amplio.",
    needhelp: "¿Necesitas ayuda?",
    subtext: "Sentido solapado",
    stepone: "Paso 1: Información básica",
    steptwo: "Paso 2: Datos de la empresa",
    stepthree: "Paso 3: Información financiera",
    welcometo: "Bienvenido a ",
    appform: "Formulario de solicitud ",
    home: "Hogar ",
    yourfullname: "Tu nombre completo",
    fullname: "Nombre completo",
    returnaportion: "Devuelve una parte de tus ingresos diarios.",
    and: "y ",
    iagreeto: "Estoy de acuerdo con ",
    Qualifyingbusinesses:
      "Las empresas calificadas reciben hasta $200,000 en 24 horas.",
    getstarted: "Comienza ahora",
    yourphone: "Tu número de teléfono",
    phone: "Número de teléfono",
    yourbusinessname: "El nombre de su empresa",
    businessname: "Nombre de su empresa",
    yourbusinesseamil: "Su correo electrónico comercial",
    inflexiblefinancing:
      "en financiación flexible, adaptada a empresas en crecimiento.",
    Receiveupto: "Recibe hasta ",
    basedonfuture: " basado en sus ingresos futuros",
    grownow: "Crece ahora",
    whyus: "¿Por qué nosotros?",
    terms: "Términos",
    privacy: "Privacidad",
    "top-rating": "Calificación 4.9",
    howitworks: "Cómo funciona",
    applynow: "Empezar",
    benefits: "Beneficios",
    faq: "Preguntas frecuentes",
    "h1-top": "Obtenga financiación empresarial",
    "h1-mid": "Hasta €1 millón",
    "h1-bot": "En 24 horas",
    "hero-text": `<b>Crezca ahora</b> en función de sus ingresos futuros. Nuestra tecnología de inteligencia artificial aprueba instantáneamente hasta $500 000 para empresas exitosas como la suya.
Desde la aprobación hasta la financiación en 24 horas.</br><b>Porque su crecimiento no puede esperar.</b>`,
    understandingcapital: "Comprendiendo el Capital de Trabajo",
    buisinessgrow: "Consejos para el crecimiento empresarial",
    financialplanning: "Planificación financiera para pequeñas empresas",
    "why-choose": "¿Por qué elegir Business Capital Advance?",
    "why-choose-descr": "Sin discursos, sin reuniones, sin complicaciones.",
    "cashAdvance.title1": "Aprobación Instantánea por IA",
    "cashAdvance.desc1":
      "Obtén hasta €500K en 24 horas. ¿Generas más de €100K? Recibe fondos mañana.",
    "cashAdvance.title2": "Pagos Basados en Ingresos",
    "cashAdvance.desc2":
      "Reembolso flexible que se ajusta al flujo de caja de tu negocio. Conserva más capital cuando lo necesites.",
    "cashAdvance.title3": "Calificación Sencilla",
    "cashAdvance.desc3":
      "No se necesita garantía: califica según la solidez de tus ingresos.",
    "cashAdvance.title4": "Solicitud en 5 Minutos",
    "cashAdvance.desc4":
      "Decisiones impulsadas por IA. Solo información básica del negocio: obtén aprobación al instante.",
    "cashAdvance.title5": "Mínima Documentación",
    "cashAdvance.desc5":
      "Proceso de solicitud optimizado pensando en tu tiempo.",
    "last-card": "¿Quieres saber más?",
    "btn-apply": "Obtén Financiamiento Ahora",
    "about-procash": "Sobre ProCash.ai",
    "desc-procash":
      "Con más de 6 años de experiencia en la financiación de empresas, ProCash.ai ha sido un socio de confianza para miles de empresas en todo EE.UU.. Nuestra misión es proporcionar soluciones de financiación flexibles y transparentes que permitan a las empresas prosperar.",
    "time-works": "6+ años",
    "our-mission":
      "Nuestra misión es impulsar el crecimiento y mejorar el progreso.",
    clients: "990+ clientes",
    "how-works": "Cómo funciona",
    "how-works.title1": "Proceso de aplicación simple",
    "how-works.desc1":
      "Completa nuestra aplicación rápida online con la información de tu negocio",
    "how-works.title2": "Aprobación rápida",
    "how-works.desc2":
      "Nuestro equipo revisa tu solicitud de forma rápida, a menudo en menos de 2 horas.",
    "how-works.title3": "Recibe fondos rápidamente ",
    "how-works.desc3":
      "Los negocios aprobados reciben fondos directamente en sus cuentas bancarias dentro de 24 horas.",
    "how-works.title4": "Reembolso flexible",
    "how-works.desc4":
      "Los reembolsos se deducen automáticamente como un porcentaje de su futuro diario, garantizando que los pagos se alineen con sus ingresos.",
    "benefits-section": "Beneficios de ProCash.ai",
    "benefits-section.title1": "Terminos Transparentes",
    "benefits-section.desc1":
      "Sin gastos ocultos ni sorpresas: entienda exactamente lo que está contratando.",
    "benefits-section.title2": "Soporte Personalizado",
    "benefits-section.desc2":
      "Nuestro equipo especializado trabajará con usted para diseñar la mejor solución de financiación para su empresa.",
    "benefits-section.title3": "Impulse su negocio",
    "benefits-section.desc3":
      "Utilice su anticipo para invertir en inventario, marketing, equipos o cualquier área que impulse el crecimiento.",
    "benefits-section.title4": "Conserva el control",
    "why-choose": "¿Por qué elegir Business Capital Advance?",
    "benefits-section.desc4":
      "A diferencia de la financiación de capital, usted conserva la plena propiedad y el control de su empresa.",
    "success-section": "Casos de éxito",
    "success-section.desc1":
      "Asociarnos con ProCash.ai supuso un cambio radical para nuestro restaurante. Los fondos nos permitieron renovar nuestro espacio y aumentar nuestro aforo, ¡lo que se tradujo en un aumento de los ingresos del 30%!",
    "success-section.owner1": "Propietario de Restaurante",
    "success-section.opening1": "Desde 2024",
    "success-section.desc2":
      "procash.ai proporcionó fondos rápidos para mi taller de reparación de automóviles. Compré nuevas herramientas y mantuve mi negocio funcionando sin problemas.",
    "success-section.owner2": "Gerente de Restaurante",
    "success-section.opening2": "Desde 2023",
    "success-section.desc3":
      "Con procash.ai, mi empresa de construcción recibió el adelanto rápidamente. ¡Compramos nuevos materiales y comenzamos más proyectos!",
    "success-section.owner3": "Propietario de Restaurante",
    "success-section.opening3": "Desde 2022",
    "faq-section-top": "¿Tienes preguntas?",
    "faq-section-bot": "¡Estamos aquí para ayudarte!",
    "faq-section-desc":
      "Contacta a nuestro amigable equipo de soporte para obtener más información sobre cómo un capital de trabajo puede beneficiar a tu negocio.",
    "faq-section-sub-section": "¿Aún tienes dudas?",
    "faq-section-sub-section-top":
      "Si la pregunta no está disponible en nuestra sección de preguntas frecuentes",
    "faq-section-sub-section-bot": "no dudes en contactarnos personalmente.",
    "faq-btn": "Haz una pregunta",
    "faq-title1": "¿Cómo puedo aplicar?",
    "faq-desc1":
      "Aplicar para un capital de trabajo con ProCash.ai es rápido y sencillo. Simplemente visita nuestro sitio web y completa el formulario de solicitud en línea con los detalles de tu negocio. Nuestro equipo revisará tu información y se pondrá en contacto contigo rápidamente para guiarte en los siguientes pasos.",
    "faq-title2": "¿Aplicar con ProCash.ai afectará mi puntaje crediticio?",
    "faq-desc2":
      "No, aplicar para un capital de trabajo con ProCash.ai no afecta tu puntaje crediticio personal o empresarial. Evaluamos tu solicitud basándonos en el flujo de efectivo y los ingresos de tu negocio, asegurando un proceso sin complicaciones y sin impactar tu historial crediticio.",
    "faq-title3": "¿Qué documentos necesito presentar para aplicar?",
    "faq-desc3":
      "Para aplicar para un capital de trabajo con ProCash.ai, necesitarás proporcionar información básica sobre tu negocio, incluyendo estados de cuenta bancarios recientes (generalmente de los últimos 3 a 6 meses) y documentos de identificación relevantes. Nuestro proceso optimizado minimiza la documentación requerida, facilitando que obtengas los fondos que necesitas.",
    "faq-title4": "¿Cómo accedo a mis fondos?",
    "faq-desc4":
      "Una vez aprobada tu solicitud, los fondos generalmente se depositan en la cuenta bancaria de tu negocio dentro de 24 a 48 horas. Priorizamos la velocidad y la eficiencia para garantizar que recibas el capital que necesitas de manera oportuna para apoyar y hacer crecer tu negocio.",

    "faq-title5": "¿Cuánto financiamiento puede obtener mi negocio?",
    "faq-desc5":
      "Tu negocio puede calificar para entre $20K y $1M en capital rápido. Un ingreso anual de $100K+ desbloquea montos más altos con aprobación instantánea. Obtén financiamiento mañana basado en el rendimiento de tus ingresos.",
    "faq-title6": "¿Cuáles son los requisitos?",
    "faq-desc6":
      "Trabajamos con negocios que cumplen con: <ul><li>+$20K de ingresos mensuales</li><li>1+ años de operación</li><li>Cuenta bancaria comercial válida</li><li>Operaciones en EE.UU.</li></ul>",
    "faq-title7": "¿Qué tan rápido puedo recibir el financiamiento?",
    "faq-desc7":
      "Los negocios que califican reciben financiamiento dentro de 24 horas después de la aprobación. Nuestra tecnología de IA proporciona decisiones instantáneas.",
    "faq-title8": "¿Mi puntaje de crédito se verá afectado por esta solicitud?",
    "faq-desc8":
      "No. Como Procahs no es un préstamo, nuestro rechazo no afectará tu puntaje de crédito.",
    "faq-title9": "¿Qué es un negocio de financiamiento de facturas?",
    "faq-desc9":
      "El financiamiento de facturas es cuando los prestamistas te ofrecen un préstamo comercial basado en tus facturas pendientes. En lugar de esperar a que los clientes paguen, un prestamista adelanta un porcentaje del valor de la factura, proporcionando flujo de efectivo inmediato. Una vez que los clientes pagan las facturas, el negocio reembolsa al prestamista, generalmente con una pequeña tarifa. Esta es una excelente opción para los negocios que necesitan acceso rápido a capital de trabajo para cubrir gastos o invertir en crecimiento.",

    "testtimonials-section": "Testimonios",
    "testimonial-desc1":
      "procash.ai me ayudó a obtener dinero rápidamente para mi restaurante. ¡Ahora puedo arreglar nuestra cocina y atender a más clientes!",
    "testimonial-user1": "Carlos",
    "testimonial-from1": "de Miami",
    "testimonial-desc2":
      "Gracias a procash.ai, mi salón de belleza recibió fondos rápidamente. ¡Compré nuevos equipos y ahora tengo más clientes!",
    "testimonial-user2": "Jasmine",
    "testimonial-from2": "de Atlanta",
    "testimonial-desc3":
      "Usar procash.ai fue muy fácil. ¡Mi boutique consiguió el efectivo que necesitaba para abastecerse para las fiestas!",
    "testimonial-user3": "Emily",
    "testimonial-from3": "de Nueva York",
    "testimonial-desc4":
      "procash.ai proporcionó fondos rápidos para mi taller de reparación de automóviles. Compré nuevas herramientas y mantuve mi negocio funcionando sin problemas.",
    "testimonial-user4": "Michael",
    "testimonial-from4": "de Chicago",
    "testimonial-desc5":
      "Con procash.ai, mi empresa de construcción recibió el adelanto rápidamente. ¡Compramos nuevos materiales y comenzamos más proyectos!",
    "testimonial-user5": "David",
    "testimonial-from5": "de Houston",
    "ready-section": "¿Listo para impulsar tu negocio hacia adelante?",
    "ready-info":
      "Da el siguiente paso en el camino de tu negocio con un capital de trabajo de ProCash.ai. Nuestro equipo está aquí para proporcionarte los fondos que necesitas con términos que se adapten a ti.",
    "ready-btn": "Crear cuenta",
    FinancialPlanning: "Planificación financiera para pequeñas empresas",
    Allrightsreserve: "Todos los derechos reservados",

    "validation.full_name.min":
      "El nombre completo debe tener al menos 2 caracteres",
    "validation.full_name.max":
      "El nombre completo no debe exceder los 50 caracteres",
    "validation.full_name.required": "El nombre completo es obligatorio",

    "validation.business_name.min":
      "El nombre del negocio debe tener al menos 2 caracteres",
    "validation.business_name.max":
      "El nombre del negocio no debe exceder los 100 caracteres",
    "validation.business_name.required": "El nombre del negocio es obligatorio",

    "validation.email.invalid": "Dirección de correo electrónico no válida",
    "validation.email.required": "El correo electrónico es obligatorio",
    "validation.policy.required": "La política de privacidad es obligatoria",
    "validation.phone.digits":
      "El número de teléfono debe contener solo dígitos",
    "validation.phone.min":
      "El número de teléfono debe tener al menos 10 dígitos",
    "validation.phone.max":
      "El número de teléfono no debe exceder los 15 dígitos",
    "validation.phone.required": "El número de teléfono es obligatorio",

    "validation.business_type.required": "El tipo de negocio es obligatorio",

    "validation.business_date.required":
      "La fecha de inicio del negocio es obligatoria",
    "validation.business_date.min_6_months":
      "La fecha de establecimiento del negocio debe ser de al menos hace 6 meses",
    phonenotvalid: "Su número de teléfono no es válido",
    thankYouMessage: "¡Gracias!",
    "validation.business_address.min":
      "La dirección del negocio debe tener al menos 5 caracteres",
    "validation.business_address.max":
      "La dirección del negocio no debe exceder los 200 caracteres",
    "validation.business_address.required":
      "La dirección del negocio es obligatoria",
    returnToTheForm: "Completa el formulario",
    "validation.business_state.required":
      "El estado del negocio es obligatorio",
    "validation.monthly_revenue.required":
      "Los ingresos mensuales son obligatorios",

    "validation.avg_monthly_credit.number":
      "El puntaje de crédito debe ser un número",
    "validation.avg_monthly_credit.required":
      "El puntaje de crédito es obligatorio",

    "validation.current_funding.required":
      "La financiación actual es obligatoria",

    "validation.consent_credit_check.required":
      "Es necesario dar consentimiento para la verificación de crédito",
    thankYouMessage2: "Antes de continuar, ¿cómo preferiría comunicarse?",
    "validation.terms_conditions.required":
      "Debe aceptar los términos y condiciones",
    thankYouMessage1:
      "Nuestro equipo ya está revisando sus datos. Un especialista en financiación le llamará en breve para finalizar su aprobación e iniciar la transferencia de sus fondos.",
  },

  setCurrent(lng) {
    this.current = lng;
  },
  getText(key, replacements = {}) {
    const translation =
      localizationModule[this.current][key] ?? localizationModule.en[key] ?? "";

    return Object.keys(replacements).reduce(
      (str, placeholder) =>
        str.replace(
          new RegExp(`{${placeholder}}`, "g"),
          replacements[placeholder]
        ),
      translation
    );
  },
};
